import { DemoAlarmSituation } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

interface SituationDTO {
  situation: string;
  alarms: {
    raw_alarm_id: string;
    old_raw_alarm_id: string;
    description?: string;
    ingestible: boolean;
    location_alarm_id?: string | null;
    partition_key?: string | null;
  }[];
}

interface SituationsResponseDTO {
  payload: {
    items: SituationDTO[];
  };
}

export function useDemoAlarmSituations() {
  const request = new Request('/v2/orm/demo_portal');

  return useAuthenticatedRequest<DemoAlarmSituation[]>(request, {
    queryKey: ['demo_portal_situations'],
    staleTime: Infinity,
    responseModifier: async (response) => {
      const json = (await response.json()) as SituationsResponseDTO;
      return json.payload.items.map((s) => ({
        situation: s.situation,
        alarms: s.alarms.map((a) => ({
          rawAlarmId: a.raw_alarm_id,
          oldRawAlarmId: a.old_raw_alarm_id,
          description: a.description,
          ingestible: a.ingestible,
          locationAlarmId: a.location_alarm_id ?? undefined,
          partitionKey: a.partition_key ?? undefined,
        })),
      }));
    },
  });
}

export default useDemoAlarmSituations;
